import React from 'react'
import PackageComponent from '../../Package'
import { Category_BestSale, } from '../../../utils/formatType'

export default function BestSaleCategory() {
  return (
    <div>
            <PackageComponent title="Bán chạy" packageId={Category_BestSale} />

    </div>
  )
}
